// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const KNOWN_NETWORK_ERRORS_LIMITED = [
	'server with the specified hostname could not be found',
	'connection failure',
	'Failed to fetch',
	'Network request failed',
	'NetworkError',
	'network error',
	'The request timed out',
	'The network connection was lost',
	'The operation was aborted',
];

const isClientFetchErrorMessage = (message: string): boolean => {
	const errorTypes = KNOWN_NETWORK_ERRORS_LIMITED;
	return (
		Boolean(message) &&
		!!errorTypes.find((networkErrorMessage) =>
			// Using `includes` here because the underlying fetch error messages
			// are sometimes wrapped to provide additional context, e.g.
			// "Something went wrong: ${error.message}"
			message.includes(networkErrorMessage),
		)
	);
};

const KNOWN_NETWORK_ERRORS_TYPES = ['AbortError', 'AuthError', 'ChunkLoadError', 'NetworkError'];

export const isClientFetchError = (error: any) =>
	Boolean(error) &&
	typeof error === 'object' &&
	(KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) ||
		isClientFetchErrorMessage(error.message) ||
		(typeof error.cause === 'object' &&
			(KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) ||
				isClientFetchErrorMessage(error.cause.message))));
